/**
 * Construit les listes du sélecteur de pays à l'ouverture.
 * Le markup produit est identique à celui que rendait Liquid : seul le moment
 * du rendu change, pour sortir 192 entrées par liste du HTML initial.
 */
(function () {
  var cache = null;

  function countries() {
    if (cache) return cache;
    var payload = document.getElementById('cv-country-data');
    if (!payload) return (cache = []);
    try {
      cache = JSON.parse(payload.textContent);
    } catch (e) {
      cache = [];
    }
    return cache;
  }

  function flagCode(isoCode) {
    var code = isoCode.toLowerCase();
    return code === 'en' ? 'gb' : code;
  }

  function buildList(list) {
    if (!list || !list.classList.contains('country-selector__list')) return;
    if (list.dataset.cvBuilt === 'true') return;

    var data = countries();
    if (!data.length) return;

    var fragment = document.createDocumentFragment();

    data.forEach(function (country) {
      var item = document.createElement('li');
      item.className = 'language-selector__item';

      var link = document.createElement('div');
      link.className = 'language-selector__link';
      link.dataset.value = country.c;

      var flag = document.createElement('img');
      flag.className = 'language-selector__flag';
      flag.setAttribute('data-flag-src', 'https://flagcdn.com/' + flagCode(country.c) + '.svg');

      link.appendChild(flag);
      link.appendChild(document.createTextNode(' ' + country.n + ' | ' + country.s + ' '));
      item.appendChild(link);
      fragment.appendChild(item);
    });

    list.appendChild(fragment);
    list.dataset.cvBuilt = 'true';
  }

  window.cvBuildCountryList = buildList;

  window.cvBuildCountryListsIn = function (root) {
    (root || document).querySelectorAll('.country-selector__list').forEach(buildList);
  };
})();
